// extracted by mini-css-extract-plugin
module.exports = {"brands":"brands_brands___FNLx","brand":"brands_brand__6g9i3","animateTopTop":"brands_animateTopTop__5oJ2U","picture":"brands_picture__JN_42","brandName":"brands_brandName__2wJXt"};